<div class="cmps-cdk-d-flex">
    <div>
        <button
            cmpsIconButton
            [cmpsTooltipTrigger]="'Expand All Sections'"
            (click)="evalRef.collapsed = false"
        >
            <cmps-icon
                class="cmps-cdk-bg-color-transparent hover:cmps-cdk-fill-unknown-121"
                [class.cmps-cdk-fill-white]="background === 'dark'"
                [class.cmps-cdk-fill-black]="background === 'light'"
                svgIcon="expand-all-outline"
            ></cmps-icon>
        </button>
    </div>
    <div>
        <button
            cmpsIconButton
            [cmpsTooltipTrigger]="'Collapse All Sections'"
            (click)="evalRef.collapsed = true"
        >
            <cmps-icon
                class="cmps-cdk-bg-color-transparent hover:cmps-cdk-fill-unknown-121"
                [class.cmps-cdk-fill-white]="background === 'dark'"
                [class.cmps-cdk-fill-black]="background === 'light'"
                svgIcon="collapse-all-outline"
            ></cmps-icon>
        </button>
    </div>
    <ng-container *ngIf="withProTips">
        <div>
            <button
                cmpsIconButton
                [cmpsTooltipTrigger]="'Expand All Pro Tips'"
                (click)="evalRef.collapsedProTips = false"
            >
                <cmps-icon
                    class="cmps-cdk-bg-color-transparent hover:cmps-cdk-fill-unknown-121"
                    [class.cmps-cdk-fill-white]="background === 'dark'"
                    [class.cmps-cdk-fill-black]="background === 'light'"
                    svgIcon="lightbulb-multiple"
                ></cmps-icon>
            </button>
        </div>
        <div>
            <button
                cmpsIconButton
                [cmpsTooltipTrigger]="'Collapse All Pro Tips'"
                (click)="evalRef.collapsedProTips = true"
            >
                <cmps-icon
                    class="cmps-cdk-bg-color-transparent hover:cmps-cdk-fill-unknown-121"
                    [class.cmps-cdk-fill-white]="background === 'dark'"
                    [class.cmps-cdk-fill-black]="background === 'light'"
                    svgIcon="lightbulb-multiple-outline"
                ></cmps-icon>
            </button>
        </div>
    </ng-container>
</div>
